import { MARQUEE } from "@/data/site";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((t, i) => (
      <span key={t} className="flex items-center">
        <span className={`whitespace-nowrap px-8 font-display text-4xl font-bold uppercase sm:text-6xl ${i % 2 ? "text-outline" : "text-slate-100"}`}>{t}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0 fill-amber-400"><path d="M3 18h18l-1.5-10-4.5 4-3-7-3 7-4.5-4z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-amber-400/20 bg-[#0b0f18] py-8" data-testid="marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
